<template>
  <span>
    <v-text-field
      v-model="model"
      :label="label"
    ></v-text-field>
    {{ description }}
  </span>
</template>

<script>
import {
  input
} from '@/mixins/input'
export default {
  computed: {
    locale: () => process.env.VUE_APP_LOCALE
  },
  data() {
    return {
    }
  },
  methods: {

  },
  mounted() {

  },
  mixins: [input]
}
</script>

<style>

</style>
